/**
 * Проверка прав на фронте — та же семантика, что у сервера
 * (App\Services\AdminApi\PermissionChecker + Str::is): в ПАТТЕРНЕ может
 * стоять `*`, например 'platform*.customers.list' покрывает и
 * 'platform.customers.list', и 'platform.tutor.customers.list'.
 *
 * ВАЖНО: это только для интерфейса — спрятать недоступный раздел или
 * действие. Источником истины остаётся сервер: каждый маршрут /admin-api
 * проверяет право сам (admin_api_permission), поэтому подделка ответа
 * /auth/me на клиенте ничего не открывает.
 */

/** Аналог Illuminate\Support\Str::is() для одного паттерна. */
function matchesPattern(pattern: string, slug: string): boolean {
  if (pattern === slug) return true;
  if (!pattern.includes('*')) return false;

  const escaped = pattern
    .split('*')
    .map((part) => part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .join('.*');

  return new RegExp(`^${escaped}$`).test(slug);
}

/** Есть ли у пользователя хотя бы одно право, подходящее под любой из паттернов. */
export function hasAnyPermission(granted: string[], patterns: string[]): boolean {
  return patterns.some((pattern) => granted.some((slug) => matchesPattern(pattern, slug)));
}
